/** Every module contract. Order is display order in directories and menus. */
import core from "./core/contract";
import herd from "./herd/contract";
import breeding from "./breeding/contract";
import genetics from "./genetics/contract";
import health from "./health/contract";
import performance from "./performance/contract";
import land from "./land/contract";
import feeding from "./feeding/contract";
import finance from "./finance/contract";
import operations from "./operations/contract";
import reports from "./reports/contract";
import sales from "./sales/contract";
import dairy from "./dairy/contract";
import sessions from "./sessions/contract";
import data from "./data/contract";
import type { ModuleContract } from "../contract";

export const contracts: ModuleContract[] = [core, herd, breeding, genetics, health, performance, land, feeding, finance, operations, reports, sales, dairy, sessions, data];
